export class NoCreditsAvailableForMonsterboard extends Error {
  constructor(message = 'No credits available for monsterboard') {
    super(message);

    this.name = 'NoCreditsAvailableForMonsterboard';
  }
}
